import { createTheme, responsiveFontSizes } from '@mui/material';
import { MuiAccordion } from './old-vy/components/mui-accordion';
import { MuiAccordionSummary } from './old-vy/components/mui-accordion-summary';
import { MuiAutocomplete } from './old-vy/components/mui-autocomplete';
import { MuiButton } from './old-vy/components/mui-button';
import { MuiChip } from './old-vy/components/mui-chip';
import { MuiFilledInput } from './old-vy/components/mui-filled-input';
import { MuiListItemButton } from './old-vy/components/mui-list-item-button';
import { MuiListItemIcon } from './old-vy/components/mui-list-item-icon';
import { MuiListItemText } from './old-vy/components/mui-list-item-text';
import { MuiListSubheader } from './old-vy/components/mui-list-subheader';
import { MuiPaper } from './old-vy/components/mui-paper';
import { MuiSwitch } from './old-vy/components/mui-switch';
import { MuiTab } from './old-vy/components/mui-tab';
import { MuiTabs } from './old-vy/components/mui-tabs';
import { MuiTextField } from './old-vy/components/mui-text-field';
import { OldVyPalette } from './old-vy/palette';
import { oldVyShadows } from './old-vy/shadows';
import { oldVyTypography } from './old-vy/typography';

export const oldVyTheme = responsiveFontSizes(
  createTheme({
    palette: OldVyPalette,
    typography: oldVyTypography,
    shadows: oldVyShadows,
    components: {
      MuiListItemButton,
      MuiListSubheader,
      MuiAutocomplete,
      MuiListItemIcon,
      MuiAccordion,
      MuiAccordionSummary,
      MuiFilledInput,
      MuiTextField,
      MuiButton,
      MuiSwitch,
      MuiPaper,
      MuiListItemText,
      MuiChip,
      MuiTabs,
      MuiTab,
    },
  }),
);
